import './kp-beta-feature.less';

/**
 * @ngdoc directive
 * @name kpBetaFeature
 * @module portaro.directives
 *
 * @description
 * Adds `beta` badge.
 */
export default class KpBetaFeatureDirective {
    public static readonly directiveName = 'kpBetaFeature';

    public restrict = 'A';
}